import { LoadingButton } from '@mui/lab';
import { Breakpoint, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem } from '@mui/material';
import * as React from 'react';
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from 'react-i18next';
import TooltipComponent from './TooltipComponent';

export interface ConfirmationButtonProps {
    action?: () => Promise<void>
    title: string | JSX.Element
    tooltip?: string
    type?: "button" | "submit" | "reset"
    buttonText?: JSX.Element | string
    buttonIcon?: JSX.Element
    fullWidth: boolean
    disabled?: boolean
    maxWidth?: false | Breakpoint | undefined
    children?: JSX.Element
    variant: "outlined" | "contained" | "text"
    asMenuItem?: boolean
    showButtons?: boolean
    childrenOpen?: boolean
    setChildrenOpen?: Dispatch<SetStateAction<boolean>>
    loading?: boolean
    color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning"
}

export interface State {
    openConfirmationBox: boolean
    doingAction: boolean
}

export const ConfirmationButton = (props: ConfirmationButtonProps) => {

    const { t } = useTranslation()
    const [openConfirmationBox, setOpenConfirmationBox] = React.useState(false)
    const [doingAction, setDoingAction] = React.useState(false)

    async function doAction(): Promise<void> {
        setDoingAction(true)

        try {
            if (props.action)
                await props.action();

            setOpenConfirmationBox(false)
        } catch (error) {
            console.error(error)
        }

        setDoingAction(false)
    }

    function OpenVerificationBox(): void {
        setOpenConfirmationBox(true)
        props.setChildrenOpen?.(true)
    }
    function CloseVerificationBox(): void {
        setOpenConfirmationBox(false)
        props.setChildrenOpen?.(false)
    }

    const buttonProps = {
        disabled: props.disabled,
        fullWidth: props.fullWidth,
        onClick: () => OpenVerificationBox(),
        color: props.color,
        loading: props.loading

    }

    return (
        <>
            <TooltipComponent placement="left" title={props.tooltip ?? props.title}>
                {props.asMenuItem ?
                    <MenuItem {...buttonProps} color="">{props.buttonText}</MenuItem> :
                    props.loading || props.buttonIcon == undefined ?
                        <LoadingButton variant={props.variant}{...buttonProps} >{props.buttonText}</LoadingButton> :
                        <IconButton sx={{paddingTop: 0, paddingBottom: 0}} {...buttonProps}>{props.buttonIcon}</IconButton>
                }
            </TooltipComponent>
            <Dialog
                fullWidth={props.fullWidth}

                open={openConfirmationBox && (props.childrenOpen === undefined || props.childrenOpen)}
                onClose={() => CloseVerificationBox()}
                aria-labelledby="alert-dialog-title"
                maxWidth={props.maxWidth}
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {props.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.children}
                    </DialogContentText>
                </DialogContent>
                {props.showButtons == undefined || props.showButtons ?
                    <DialogActions>
                        <Button className="decline__button" onClick={() => CloseVerificationBox()} autoFocus>{t("No") + ""}</Button>
                        <LoadingButton loading={doingAction || props.loading} type={props.type} className="accept__button" color="primary" variant="contained" onClick={async () => await doAction()} >
                            {t("Yes") + ""}
                        </LoadingButton>
                    </DialogActions> : <></>
                }
            </Dialog>
        </>
    )
}

ConfirmationButton.defaultProps = {
    color: "warning",
    variant: "outlined",
    className: "",
    fullWidth: false
};